import { useEffect, useRef, useState } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

const useGoogleMapScriptLoader = () => {
    const isMounted = useRef(false);

    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState<Error>(null);

    useEffect(() => {
        if (isMounted.current) return;

        const loader = new Loader({
            apiKey: import.meta.env.VITE_APP_GOOGLE_MAPS_KEY,
            version: 'weekly',
        });

        Promise.all([loader.importLibrary('maps'), loader.importLibrary('marker')])
            .then(() => {
                setIsLoaded(true);
            })
            .catch((err) => {
                setError(err as any);
            });

        isMounted.current = true;

        return () => {
            isMounted.current = false;
        };
    }, []);

    return {
        isLoaded,
        error,
    };
};

export default useGoogleMapScriptLoader;
